import axios from "axios";
import store from "@/store";
import router from "@/router";

axios.interceptors.request.use(
  config => {
    config.headers.authorization = "Bearer " + localStorage.getItem("token");
    store.dispatch("ADD_LOADING");
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    store.dispatch("REM_LOADING");
    return response;
  },
  error => {
    error = error.response.data;
    store.dispatch("REM_LOADING");
    if (error.msg.includes("jwt expired")) {
      router.push({ name: "auth.login" });
      store.dispatch("auth/LOGOUT");
    }
    return Promise.reject(error);
  }
);

export default axios;
